// custom.js · PixelNova Solutions · 2026-09-29
// Added: the desktop search placeholder now reads "Search products" (the old line blanked it) and is null-safe
// Removed: nothing else; the Made in USA menu badge script stays, kn-header.css hides that menu item
<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

document.addEventListener("DOMContentLoaded", function() {

  document.querySelectorAll(".flag-button").forEach(button => {
    button.addEventListener("click", function () {
      const modalId = this.getAttribute("data-modal");
      const modal = document.getElementById(modalId);
      modal.classList.add("show"); // fade in
    });
  });

  document.querySelectorAll(".close").forEach(span => {
    span.addEventListener("click", function () {
      const modal = this.closest(".modal");
      modal.classList.remove("show"); // fade out
    });
  });

  window.addEventListener("click", function (e) {
    document.querySelectorAll(".modal").forEach(modal => {
      if (e.target === modal) {
        modal.classList.remove("show"); // fade out
      }
    });
  });
});

// TBD
document.addEventListener("DOMContentLoaded", function() {
  // Only run on this specific route
  if (window.location.pathname !== "/pages/photo-gallery") {
    return;
  }
  

const lightbox = document.getElementById("lightbox");
const lightboxImg = document.getElementById("lightbox-img");
const closeBtn = document.querySelector(".lightbox .close");

document.querySelectorAll(".masonry img").forEach(img => {
  img.addEventListener("click", () => {
    lightbox.style.display = "flex";
    lightboxImg.src = img.src;
  });
});

closeBtn.addEventListener("click", () => {
  lightbox.style.display = "none";
});

lightbox.addEventListener("click", (e) => {
  if (e.target === lightbox) lightbox.style.display = "none";
});

});


document.addEventListener("DOMContentLoaded", function () {
  // Only run on this specific route
  if (window.location.pathname !== "/pages/flagpole-installations-louisiana") {
    return;
  }

  const form = document.querySelector(".louis_stick");
  const startPoint = 200; // px from top to start sticking

  window.addEventListener("scroll", function () {
    const scrollY = window.scrollY;

    if (scrollY > startPoint) {
      form.style.position = "fixed";
      form.style.top = "2rem"; // distance from top while fixed
      form.style.right = "5%"; // adjust depending on layout
      form.style.width = "45%"; // keep consistent width
    } else {
      form.style.position = "relative";
      form.style.top = "0";
      form.style.right = "auto";
      form.style.width = "auto";
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const last_item = document.querySelector('#HeaderNavigation > nav > ul > li:nth-child(6) > a > span');

  if (last_item) {
  const img = document.createElement('img');
  img.src = 'https://cdn.shopify.com/s/files/1/0508/7576/0829/files/Made_in_USA_Logo_Emblem_1_1.png?v=1765211849'; // Update with your image path
  img.style.width = "190px"
  img.alt = 'Navigation Icon';
  last_item.replaceWith(img);
}
});

document.addEventListener("DOMContentLoaded", () => {
  // 2026-09-29 PixelNova: the new nav row shows its search as a pill with a visible prompt, so this sets it instead of blanking it
  const search = document.querySelector('.section-header-navigation .search__input.field__input');
  if (search) search.placeholder = "Search products";
});